import { createSSRApp } from 'vue'
import AvatarFrame from '@/components/AvatarFrame/index.vue'
import App from './App.vue'
import { channelInterceptor } from './interceptors/channel'
import { prototypeInterceptor, requestInterceptor, routeInterceptor } from './interceptors'
import i18n from './locales'
import store from './store'
import '@/style/index.scss'
import 'virtual:uno.css'

// #ifdef H5
interface VConsoleInstance {
  destroy: () => void
}

async function setupVConsole() {
  const enableEnvs = ['sit', 'uat']
  if (!enableEnvs.includes(import.meta.env.VITE_NODE_ENV))
    return
  if (typeof window === 'undefined')
    return

  const win = window as Window & { __HK_VCONSOLE__?: VConsoleInstance }
  if (win.__HK_VCONSOLE__)
    return

  const { default: VConsole } = await import('vconsole')
  win.__HK_VCONSOLE__ = new VConsole()
}

void setupVConsole()
// #endif

export function createApp() {
  const app = createSSRApp(App)
  app.config.globalProperties.$imageUrl = import.meta.env.VITE_SERVER_ASSETS
  app.use(store)
  app.use(i18n)
  app.use(channelInterceptor)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.component('AvatarFrame', AvatarFrame)
  app.config.compilerOptions.isCustomElement = (tag) => {
    return tag.startsWith('wx-open-')
  }

  return {
    app,
  }
}
